import { useCallback } from 'react';
import { useSMLRouter } from '../../../../../routing/sml/hooks';
import { SMLRoutes } from '../../../../../routing/sml/SMLRoutes';

/**
 * "Open Calendar" of a release: the Calendar with the song filter of this release (`?songs=`), so
 * it shows the posts of the release only.
 */
export function useOpenReleaseCalendar(catalogItemUuid: string): (post?: string) => void {
  const router = useSMLRouter();
  return useCallback(
    (post?: string) =>
      router.push(
        SMLRoutes.promoteCalendar,
        post === undefined ? { songs: catalogItemUuid } : { songs: catalogItemUuid, post }
      ),
    [catalogItemUuid, router]
  );
}
